import React, { Component, PropTypes } from "react";

import Navbar from "components/Global/Navbar";
import Footer from "components/Global/Footer";

export default class App extends Component {
	static propTypes = {
		children: PropTypes.object,
	}

	render() {
		const { children } = this.props;

		return (
			<div className="App">
				<Navbar />

				<div className="Page">
					{ children }
				</div>

				<Footer />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./js/views/App/index.jsx